var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-form-row',_vm._b({attrs:{"name-cols":"8","cols":"auto"},scopedSlots:_vm._u([{key:_vm.name,fn:function(){return [_c('span',{staticClass:"text-body-2 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.unit)}})])]},proxy:true}],null,true)},'sidebar-form-row',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }